"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.beginLogInByTransactionFragmentDependencies = exports.beginLogInByTransactionFragment = void 0;
exports.beginLogInByTransactionFragment = `
fragment beginLogInByTransactionFragment on BeginLogInByTransactionResult {
  nonce
}
`.trim();
exports.beginLogInByTransactionFragmentDependencies = [
    exports.beginLogInByTransactionFragment,
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmVnaW5Mb2dJbkJ5VHJhbnNhY3Rpb25GcmFnbWVudC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL2xpYi9mcmFnbWVudHMvYmVnaW5Mb2dJbkJ5VHJhbnNhY3Rpb25GcmFnbWVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLCtCQUErQixHQUFHOzs7O0NBSTlDLENBQUMsSUFBSSxFQUFFLENBQUM7QUFFSSxRQUFBLDJDQUEyQyxHQUFHO0lBQ3pELHVDQUErQjtDQUNoQyxDQUFDIn0=